import React, { memo } from 'react';

import StarredSection from './StarredSection/StarredSection';
import TeamSection from './TeamSection/TeamSection';
import GroupSection from './GroupSection/GroupSection';

type Props = {
  showFeature?: Function;
  onCloseNavbar?: Function;
};

function TeamGroupSection({ showFeature = () => null, onCloseNavbar = () => null }: Props) {
  return (
    <>
      <StarredSection onCloseNavbar={onCloseNavbar} />
      <TeamSection showFeature={showFeature} onCloseNavbar={onCloseNavbar} />
      <GroupSection onCloseNavbar={onCloseNavbar} />
    </>
  );
}

export default memo(TeamGroupSection);
